import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useI18n } from "../lib/i18n";

const LANGS = [
  { code: "fr", country: "fr", label: "FR", name: "Français" },
  { code: "en", country: "gb", label: "EN", name: "English" },
  { code: "vi", country: "vn", label: "VI", name: "Tiếng Việt" },
];

const Flag = ({ country, label }) => (
  <img
    src={`https://flagcdn.com/24x18/${country}.png`}
    srcSet={`https://flagcdn.com/48x36/${country}.png 2x`}
    width={18}
    height={13}
    alt={label}
    loading="lazy"
    className="h-[13px] w-[18px] shrink-0 rounded-[2px] object-cover ring-1 ring-black/20"
  />
);

export function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const cur = LANGS.find((l) => l.code === lang) || LANGS[0];
  const pick = (l) => {
    setLang(l);
    localStorage.setItem("lc_lang", l);
    document.documentElement.lang = l;
    setOpen(false);
  };
  return (
    <div className={`relative ${className}`} data-testid="language-toggle">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="language-toggle-btn"
        className="flex items-center gap-1.5 rounded-full border border-cardline bg-ink2/60 px-2.5 py-1.5 text-[11px] font-semibold text-slate-200 hover:border-gold/50"
      >
        <Flag country={cur.country} label={cur.label} /> {cur.label}
        <ChevronDown size={13} className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <button className="fixed inset-0 z-[900] cursor-default" onClick={() => setOpen(false)} aria-hidden tabIndex={-1} />
          <div className="absolute right-0 z-[901] mt-1 w-40 overflow-hidden rounded-xl border border-cardline bg-card2 shadow-2xl" role="menu">
            {LANGS.map((l) => (
              <button
                key={l.code}
                onClick={() => pick(l.code)}
                data-testid={`lang-${l.code}`}
                role="menuitem"
                className={`flex w-full items-center gap-2.5 px-3 py-2.5 text-left text-xs font-semibold transition-colors ${
                  lang === l.code ? "bg-gold/15 text-gold" : "text-slate-200 hover:bg-ink2/60"
                }`}
              >
                <Flag country={l.country} label={l.label} /> {l.name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
